module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/mg-home/',
  octopusPackageId: 'my-garage-home',
  octopusProjectName: 'My Garage Home',
  mountDOMId: '__app__',
  standalone: false
};